<!-- SAML -->
<log-cinematic-sub-section-wrapper
    *ngIf="samlLog$ | async"
    header="{{ l10nKeys.samlLabel | vtranslate }}"
>
    <log-cinematic-sub-section-saml></log-cinematic-sub-section-saml>
</log-cinematic-sub-section-wrapper>

<!-- JWT -->
<log-cinematic-sub-section-wrapper
    *ngIf="jwtLog$ | async"
    header="{{ l10nKeys.jwtLabel | vtranslate }}"
>
    <log-cinematic-sub-section-jwt></log-cinematic-sub-section-jwt>
</log-cinematic-sub-section-wrapper>

<!-- OAuth -->
<log-cinematic-sub-section-wrapper
    *ngIf="oAuthLog$ | async"
    header="{{ l10nKeys.oAuthLabel | vtranslate }}"
>
    <log-cinematic-sub-section-o-auth></log-cinematic-sub-section-o-auth>
</log-cinematic-sub-section-wrapper>

<!-- NTLM -->
<log-cinematic-sub-section-wrapper
    *ngIf="ntlmLog$ | async"
    header="{{ l10nKeys.ntlmLabel | vtranslate }}"
>
    <log-cinematic-sub-section-ntlm></log-cinematic-sub-section-ntlm>
</log-cinematic-sub-section-wrapper>
